import EventEmitter from './helper/event-emitter.js';
import { updateObject, hasOwnProperty } from './helper/utils.js';
import { isString } from './helper/validator.js';

export default class Communicator {
  _userInfo = {
    appKey: '',
    userId: '',
    examNo: ''
  };

  get _webview() {
    switch (true) {
      case !!window.chrome:
        return window.chrome.webview;
      case !!window.webkit:
        return window.webkit;
      default:
        return null;
    }
  }

  _postMessage(msg) {
    return this._webview?.postMessage(msg);
  }

  _getMsgObject(command, property) {
    if (!property) {
      return JSON.stringify({ command });
    } else {
      return JSON.stringify({ command, property });
    }
  }

  initialize(userInfo) {
    const requiredKeys = ['userId', 'examNo', 'appKey'];
    if (!userInfo || !requiredKeys.every((key) => !!userInfo[key] && isString(userInfo[key]))) {
      throw Error('Check user info config.');
    }

    updateObject(this._userInfo, userInfo);

    if (this._webview) {
      this._webview.addEventListener('message', ({ data }) => {
        const key = 'msgFromProctor';
        const msgFromProctorEl = document.getElementById(key);
        if (hasOwnProperty(data, key) && msgFromProctorEl) {
          msgFromProctorEl.value = data[key];
        }
      });
    }
    return this._postMessage(this._getMsgObject('initialize', this._userInfo));
  }

  communicate() {
    switch (arguments.length) {
      case 0:
        console.log('[communicate] communicate() There are no arguments.');
        break;
      case 1:
      case 2:
        console.log('[communicate] communicate(1 ~ 2):', arguments);
        return this._postMessage(this._getMsgObject(...arguments));
      default:
        console.log('[communicate] communicate() Invalid arguments.');
        break;
    }
  }

  beginTest() {
    EventEmitter.fire('beginTest');
    this.communicate('beginTest');
  }

  endTest() {
    EventEmitter.fire('endTest');
    this.communicate('endTest');
  }
}
